module.exports = __webpack_public_path__ + "img/104.7a27e5ea.png";